document.addEventListener("DOMContentLoaded", function() {
    const bestSellersLinks = document.querySelectorAll('a[href="/collections/all?sort_by=best-selling"]');
    console.log("bestSellersLink", bestSellersLinks)
  
    bestSellersLinks.forEach(link => {
      link.classList.add("tooltip-link");
    });
  
    const reviewsTarget = document.querySelector(".template-index .shopify-app-block .jdgm-all-reviews-text");
    const destinationDiv = document.querySelector(".template-index .slideshow .slideshow-slide__text .slideshow-slide__title");
  
    if (reviewsTarget && destinationDiv) {
      destinationDiv.prepend(reviewsTarget);
    }
  
    if (window.innerWidth <= 992) {
      const titleTarget = document.querySelector("body.template-product .product__inventory");
      const titleTarget_h2 = document.querySelector("body.template-product .product__title");
      const priceTarget = document.querySelector("body.template-product .simple-price-title-unstyled");
      const destinationTitle = document.querySelector("body.template-product .titler-mobile");

      if (titleTarget_h2 && destinationTitle) {
        destinationTitle.prepend(titleTarget_h2);
      }
      if (priceTarget && destinationTitle) {
        destinationTitle.appendChild(priceTarget);
      }
      if (titleTarget && destinationTitle) {
        destinationTitle.prepend(titleTarget);
      }
    }
  });
  
  $(document).ready(function () {
    console.log("Run bundles");
  
    $('.custom-packs-canvas__products--collections--list').slick({
        arrows: true,
        dots: false,
        slidesToShow: 4,
        infinite: false,
        responsive: [
          {
            breakpoint: 1360,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 992,
            settings: {
              arrows: false,
              slidesToShow: 2.1
            }
          }
        ]
    });
  
    $('.custom-packs-canvas__products--tabs button').on('click', function() {
      $('.custom-packs-canvas__products--tabs button').removeClass('active');
      $('.custom-packs-canvas__products--collections--list').removeClass('active');
  
      $(this).addClass('active');
  
      const target = $(this).attr('class').split(' ').find(c => c.startsWith('tab-'));
      $(`.custom-packs-canvas__products--collections--list[rel-target="${target}"]`).addClass('active');
    });
  
    const bundleItems = []
  
    function updateBundle(bundleItems) {
      console.log("bundleItems", bundleItems)
      let percentDiscount = 0;
  
      // Parsear precios correctamente (Shopify los devuelve en centavos)
      const total = bundleItems.reduce((sum, item) => {
        // Asegurarse de que el precio es un número válido
        let price = Number(item.price);
        // Si el precio es muy pequeño (menos de 100), podría estar ya en euros, multiplicar por 100
        // Pero normalmente Shopify devuelve en centavos, así que si es menor a 1000, asumimos que está en centavos
        console.log("Item price:", item.price, "Parsed:", price);
        return sum + price;
      }, 0);
      const eursTotal = total / 100;
      console.log("Total (centavos):", total, "Total (euros):", eursTotal);
  
      let templateSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
        <mask id="mask0_7114_790" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="24">
          <rect x="0.5" width="24" height="24" fill="#3F3F3F"/>
        </mask>
        <g mask="url(#mask0_7114_790)">
          <path d="M11.5 21V13H3.5V11H11.5V3H13.5V11H21.5V13H13.5V21H11.5Z" fill="#3F3F3F"/>
        </g>
      </svg>`
  
      document.querySelector('#bundle-item-1').innerHTML = templateSvg
      document.querySelector('#bundle-item-2').innerHTML = templateSvg
      document.querySelector('#bundle-item-3').innerHTML = templateSvg
  
      if (bundleItems.length == 0) {
        percentDiscount = 0;
        document.querySelector('.custom-packs-canvas__pack--bar__progress').style.width = '0%'
        document.querySelector('.custom-packs-canvas__pack--totals__actions').classList.remove('active')
      } else {
        document.querySelector('.custom-packs-canvas__pack--totals__actions').classList.add('active')
      }
  
      if (bundleItems[0]) {
        document.querySelector('#bundle-item-1').innerHTML = `<img src="${bundleItems[0].image}" /> <button class="remove-item"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M1.01679 9.61641L0.290039 8.88966L4.23604 4.94341L0.290039 1.02216L1.01679 0.29541L4.96304 4.24141L8.88429 0.29541L9.61104 1.02216L5.66504 4.94341L9.61104 8.88966L8.88429 9.61641L4.96304 5.67041L1.01679 9.61641Z" fill="#AC8881"/></svg></button>`
        document.querySelector('.custom-packs-canvas__pack--bar__progress').style.width = '25%'
        percentDiscount = 0;
      }
      if (bundleItems[1]) {
        document.querySelector('#bundle-item-2').innerHTML = `<img src="${bundleItems[1].image}" /> <button class="remove-item"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M1.01679 9.61641L0.290039 8.88966L4.23604 4.94341L0.290039 1.02216L1.01679 0.29541L4.96304 4.24141L8.88429 0.29541L9.61104 1.02216L5.66504 4.94341L9.61104 8.88966L8.88429 9.61641L4.96304 5.67041L1.01679 9.61641Z" fill="#AC8881"/></svg></button>`
        document.querySelector('.custom-packs-canvas__pack--bar__progress').style.width = '50%'
        percentDiscount = 0.10;
      }
      if (bundleItems[2]) {
        document.querySelector('#bundle-item-3').innerHTML = `<img src="${bundleItems[2].image}" /> <button class="remove-item"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M1.01679 9.61641L0.290039 8.88966L4.23604 4.94341L0.290039 1.02216L1.01679 0.29541L4.96304 4.24141L8.88429 0.29541L9.61104 1.02216L5.66504 4.94341L9.61104 8.88966L8.88429 9.61641L4.96304 5.67041L1.01679 9.61641Z" fill="#AC8881"/></svg></button>`
        document.querySelector('.custom-packs-canvas__pack--bar__progress').style.width = '100%'
        document.querySelector('.custom-packs-canvas__pack--totals__actions').classList.add('active')
        percentDiscount = 0.15;
      }
  
      // Calcular descuento en euros (no en centavos)
      const eursTotalDiscount = eursTotal * percentDiscount;
      const formatMoneyDiscount = new Intl.NumberFormat("es-ES", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(eursTotalDiscount);
      document.querySelector('#discounts-bundle').innerHTML = `${formatMoneyDiscount}`

      // Calcular total final restando el descuento
      const totalFinal = eursTotal - eursTotalDiscount;
      const formatMoney = new Intl.NumberFormat("es-ES", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(totalFinal);
      
      // Mostrar precio original tachado cuando hay descuento
      const originalTotalElement = document.querySelector('#total-original-bundle');
      if (percentDiscount > 0 && originalTotalElement) {
        const formatOriginalMoney = new Intl.NumberFormat("es-ES", {
          style: "currency",
          currency: "EUR",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(eursTotal);
        originalTotalElement.innerHTML = formatOriginalMoney;
        originalTotalElement.style.display = 'inline-block';
        originalTotalElement.style.textDecoration = 'line-through';
        originalTotalElement.style.color = '#999';
        originalTotalElement.style.marginRight = '0.5rem';
      } else if (originalTotalElement) {
        originalTotalElement.style.display = 'none';
      }
      
      document.querySelector('#total-bundle').innerHTML = `${formatMoney}`
    }

    function resetModal () {
      if (document.querySelector('.cap-editor-modal')) {
        document.querySelector('.cap-editor-modal .cap-text-input').value = '' 
      }
      if (document.querySelector('.scarf-editor-modal')) {
        document.querySelector('.scarf-editor-modal .cap-text-input').value = '' 
      }

    }
  
    $('.custom-packs-canvas__products--collections--list__item--add').click(function(e) {
      console.log("Add from bundle")
      resetModal();
      const variant = e.target.closest('.custom-packs-canvas__products--collections--list__item--add').getAttribute('rel-variant')
      const image = e.target.closest('.custom-packs-canvas__products--collections--list__item').querySelector('.custom-packs-canvas__products--collections--list__item--image img').getAttribute('src')
      const price = e.target.closest('.custom-packs-canvas__products--collections--list__item').getAttribute('rel-price')
      const name = e.target.closest('.custom-packs-canvas__products--collections--list__item').getAttribute('rel-title')

      if (bundleItems.length < 3) {
        if (name.includes('Scarf')) {
          // Guardar el precio correcto del producto para usar después en el modal
          document.querySelectorAll('.scarf-editor-modal').forEach(modal => {
            modal.setAttribute('data-bundle-price', price);
          });
          document.querySelectorAll('.open-scarf-customizer')[0].click()

          for (let index = 0; index < document.querySelectorAll('.scarf-editor-modal.show .cap-color-swatch').length; index++) {
            const el = document.querySelectorAll('.scarf-editor-modal.show .cap-color-swatch')[index];
            if (el.getAttribute('data-id') == variant) {
              el.click()
            }
          }

         } else if (name.includes('Cap')) {
          // Guardar el precio correcto del producto para usar después en el modal
          document.querySelectorAll('.cap-editor-modal').forEach(modal => {
            modal.setAttribute('data-bundle-price', price);
          });
          document.querySelectorAll('.open-cap-customizer')[0].click()

          for (let index = 0; index < document.querySelectorAll('.cap-editor-modal.show .cap-color-swatch').length; index++) {
            const el = document.querySelectorAll('.cap-editor-modal.show .cap-color-swatch')[index];
            if (el.getAttribute('data-id') == variant) {
              el.click()
            }
          }

        } else {
          bundleItems.push({
            variant: variant,
            image: image,
            price: price
          })
        }
      }
      updateBundle(bundleItems);
    });

    $('.template-index .cap-editor-controls .button.button--primary').click(function(e) {
      let isCap = true

      if (document.querySelector('.scarf-editor-modal.show')) {
        isCap = false
      }

      const bundleVariantId = e.target.closest('.cap-editor-controls').querySelector('.cap-color-swatch.active').getAttribute('data-id')
      const bundleVariantImage = e.target.closest('.cap-editor-controls').querySelector('.cap-color-swatch.active').getAttribute('data-img')
      
      // Obtener el precio correcto del modal (guardado desde el producto original)
      // Si no está disponible, usar el data-price del swatch como fallback
      const modal = document.querySelector('.cap-editor-modal.show') || document.querySelector('.scarf-editor-modal.show');
      const bundleVariantPrice = modal?.getAttribute('data-bundle-price') || 
                                 e.target.closest('.cap-editor-controls').querySelector('.cap-color-swatch.active').getAttribute('data-price');

      const bundleVariantColor = e.target.closest('.cap-editor-controls').querySelector('.capColorInput').value
      const bundleVariantText = e.target.closest('.cap-editor-controls').querySelector('.capTextInputHidden').value

      bundleItems.push({
        variant: bundleVariantId,
        image: bundleVariantImage,
        price: bundleVariantPrice,
        properties: {
          "Color": bundleVariantColor,
          "Text": bundleVariantText
        }
      })
      updateBundle(bundleItems);
      if (document.querySelector('.cap-editor-modal.show')) {
        document.querySelector('.cap-editor-modal.show .cap-editor-close').click()
      }
      if (document.querySelector('.scarf-editor-modal.show')) {
        document.querySelector('.scarf-editor-modal.show .cap-editor-close').click()
      }
    });
    
  
     $(document).on('click', '#bundle-item-1 .remove-item', function() {
      bundleItems.splice(0, 1);
      updateBundle(bundleItems);
    });
    $(document).on('click', '#bundle-item-2 .remove-item', function() {
      bundleItems.splice(1, 1);
      updateBundle(bundleItems);
    });
    $(document).on('click', '#bundle-item-3 .remove-item', function() {
      bundleItems.splice(2, 1);
      updateBundle(bundleItems);
    });
  
    $('.custom-packs-canvas__pack--totals__actions button').click(function() {
      if (bundleItems.length >= 1) {
        const lineItems = bundleItems.map(item => ({
          id: Number(item.variant),
          quantity: 1,
          properties: item.properties
        }));
  
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: lineItems
          })
        })
        .then(res => res.json())
        .then(data => {
          console.log('Items agregados:', data);
          window.location.href = '/cart'
  
        })
        .catch(err => console.error('Error:', err));
  
      }
    });
    
    $('.custom-product-upsells__slider--item__action.modal').click(function(e) {
      e.preventDefault();
      const productType = $(this).attr('data-product-type');
      
      console.log('Upsell clicked:', productType);
      
      if (productType === 'gorra') {
        // Buscar el botón de gorra y hacer clic
        const capButton = document.querySelector('.open-cap-customizer');
        if (capButton) {
          capButton.click();
        } else {
          console.error('Botón de gorra no encontrado');
        }
      } else if (productType === 'bufanda') {
        // Buscar el botón de bufanda y hacer clic
        const scarfButton = document.querySelector('.open-scarf-customizer');
        if (scarfButton) {
          scarfButton.click();
        } else {
          console.error('Botón de bufanda no encontrado');
        }
      }
    });

    // Manejador específico para upsells de bufanda (cuando no hay botón visible)
    $('.custom-product-upsells__slider--item__action[data-product-type="bufanda"]').click(function(e) {
      e.preventDefault();
      console.log('Upsell bufanda clicked - abriendo modal directamente');
      
      // Abrir el modal de bufanda directamente
      const scarfModal = document.getElementById('scarfEditorModal');
      if (scarfModal) {
        scarfModal.classList.add('show');
        
        // Inicializar el slider si es necesario
        if (typeof $ !== 'undefined' && $.fn.slick) {
          $('#scarfEditorModal .cap-color-options').slick({
            arrows: true,
            dots: false,
            slidesToShow: 7,
            infinite: false
          });
        }
        
        // Configurar el estado inicial
        const activeColorSwatch = document.querySelector("#scarfEditorModal .cap-color-swatch.active");
        const capImage = document.getElementById("scarfPreviewImage");
        const colorHidden = document.getElementById("scarfColorInput");
        const variantIdInput = document.getElementById("scarfVariantId");
        const colorNameDisplay = document.getElementById("capColorName");

        if (activeColorSwatch && capImage) {
          capImage.src = activeColorSwatch.dataset.img;
          colorHidden.value = activeColorSwatch.dataset.name;
          variantIdInput.value = activeColorSwatch.dataset.id;
          colorNameDisplay.textContent = activeColorSwatch.dataset.name;
        }

        const textInput = document.getElementById("scarfTextInput");
        const capText = document.getElementById("scarfPreviewText");
        const textHidden = document.getElementById("scarfTextInputHidden");
        const value = textInput?.value?.trim() || "";
        capText.textContent = value || " ";
        textHidden.value = value;

        // Aplicar fuente por defecto
        if (capText) {
          capText.style.fontFamily = "'Futura', sans-serif";
        }

        if (window.innerWidth < 769) {
          // Mostrar step 1 en móvil
          const steps = document.querySelectorAll("#scarfEditorModal .cap-step");
          steps.forEach(s => s.classList.remove("active"));
          const firstStep = document.querySelector("#scarfEditorModal .cap-step[data-step='1']");
          if (firstStep) firstStep.classList.add("active");
        }
      } else {
        console.error('Modal de bufanda no encontrado');
      }
    });

    // Manejador para añadir gafas al carrito directamente
    $('.custom-product-upsells__slider--item__action.add-to-cart').click(function(e) {
      e.preventDefault();
      const variantId = $(this).attr('data-variant-id');
      
      if (!variantId) {
        console.error('Variant ID no encontrado');
        return;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
      .then(response => response.json())
      .then(data => {
        console.log('Gafas agregadas al carrito:', data);
      
        publish(PUB_SUB_EVENTS.cartUpdate, {source: 'upsell-glasses', productVariantId: variantId});
        
        // Abrir el cart drawer
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          cartDrawer.open();
        } else {
          // Fallback: intentar abrir el drawer manualmente
          const drawerElement = document.getElementById('CartDrawer');
          if (drawerElement) {
            drawerElement.classList.add('active');
          }
        }
      })
      .catch(err => {
        console.error('Error al añadir gafas al carrito:', err);
      });
    });
  
    $('.home-customizer .product-card a').click(function(e) {
      // e.preventDefault()
      // const link = e.target.getAttribute('href')
      // window.location.href= '/products/gorra-personalizada'
    });
    
    
    $('.custom-product-upsells__slider--item__action.real').click(function(e) {
      const variant = e.target.closest('.real').getAttribute('rel-variant')
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variant,
          quantity: 1
        })
      })
      .then(response => response.json())
      .then(data => {
        console.log('Producto agregado:', data);
  
          publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: variant});
  
          const itemsCart = document.querySelectorAll('.drawer__cart-items .cart-item')[0]
          if (itemsCart) {
            console.log("add")
            itemsCart.querySelector('.cart-item__quantity-wrapper button[name="plus"]').click()
  
            setTimeout(() => {
              console.log("remove")
              itemsCart.querySelector('.cart-item__quantity-wrapper button[name="minus"]').click()
  
              setTimeout(() => {
                const cartDrawer = document.querySelector('cart-drawer');
                if (cartDrawer) cartDrawer.open();
              }, 500);
  
            }, 2000);
          }
  
  
  
      })
      .catch(error => {
        console.error('Error al agregar al carrito:', error);
      });
    });
  
    $('.product__info-container .custom-product-upsells__slider').slick({
        arrows: true,
        dots: false,
        slidesToShow: 1,
        infinite: false
    });
  
  
    // Manejador para bundle creator (home page) - REMOVIDO: ahora se maneja directamente en cap-customizer.liquid
  
  
    // Manejador para bundle creator (home page) - REMOVIDO: ahora se maneja directamente en scarf-customizer.liquid
  
  
    $('#add-cat-from-cart').click(function(e) {
      $('#CartDrawer-Overlay').click();
      $('.open-cap-customizer.listener-attached').click();
    });
    $('#add-scarf-from-cart').click(function(e) {
      $('#CartDrawer-Overlay').click();
      $('.open-scarf-customizer.listener-attached').click();
    });


    $(document).on('click', '#add-upsell-from-cart', function(e) {
        const variant = e.target.closest('#add-upsell-from-cart').getAttribute('data-variant')
  
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: variant,
            quantity: 1
          })
        })
        .then(response => response.json())
        .then(data => {
          console.log('Producto agregado:', data);
          window.location.href = '/cart'
        })
        .catch(error => {
          console.error('Error al agregar al carrito:', error);
        });
  
    });
  
  
  
  
    const slickInterval = setInterval(() => {
      const $slider = $('.drawer__footer .custom-product-upsells__slider');
  
      if ($slider.length && !$slider.hasClass('slick-initialized')) {
        $slider.slick({
          arrows: true,
          dots: false,
          slidesToShow: 1,
          infinite: false
        });
      }
    }, 100);
  
  
    /* pdp gallery mobile */
    if (window.innerWidth <= 992) {
      // Solo inicializar si no están ya inicializados
      if (!$('.template-product .product__media-wrapper').hasClass('slick-initialized')) {
        $('.template-product .product__media-wrapper').slick({
            arrows: false,
            dots: false,
            slidesToShow: 1,
            infinite: false,
            asNavFor: '.product__media-thumbnails'
        });
      }
      
      if (!$('.product__media-thumbnails').hasClass('slick-initialized')) {
        $('.product__media-thumbnails').slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          asNavFor: '.template-product .product__media-wrapper',
          dots: false,
          centerMode: false,
          focusOnSelect: true,
          arrows: false
        });
      }
    }
    
    function updateFreebarInit(activeLevel) {
          const labels = document.querySelectorAll('.drawer__freebar--labels span');
          labels.forEach(label => label.classList.remove('active'));
  
          if (activeLevel >= 1) {
              document.querySelector('.drawer__freebar--labels .freebar-pos-1')?.classList.add('active');
          }
          if (activeLevel >= 2) {
              document.querySelector('.drawer__freebar--labels .freebar-pos-2')?.classList.add('active');
          }
          if (activeLevel >= 3) {
              document.querySelector('.drawer__freebar--labels .freebar-pos-3')?.classList.add('active');
          }
  
          const progress = document.querySelector('.drawer__freebar--bar__progress');
          if (progress) {
              let width = 0;
              if (activeLevel === 1) width = 20;
              else if (activeLevel === 2) width = 50;
              else if (activeLevel >= 3) width = 100;
              progress.style.width = `${width}%`;
          }
      }
  
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        updateFreebarInit(cart.item_count)
      })
      .catch(error => {
        console.error('Error al obtener el carrito:', error);
      });
  
  });